var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtsyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H2v209h209V2H4zm142.422 151.982v38.115H20.788V20.9h171.419v171.197h-27.123v-40.115h-18.662v2zM70.434 37.965h-1.368l-.496 1.276-30.142 77.581-1.059 2.725h19.898l.485-1.301 7.657-20.535h26.434l7.54 20.525.482 1.311h19.912l-1.058-2.725-30.143-77.581-.495-1.276H70.434h0zm.36 42.645l7.128-19.196 7.035 19.196H70.794z",
    fill: "#535A5B",
    stroke: "#535A5B",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtsyIcon);
export default __webpack_public_path__ + "static/media/artsy-icon.ebe841bbc0e05317cbadb7267342cb55.svg";
export { ForwardRef as ReactComponent };